import { Component, inject } from '@angular/core';
import { AppStateService } from '../../../core/app-state/app-state.service';
import { SiteFooterComponent } from '../../../design/components/site-footer/site-footer.component';
import { LandingChartGalleryComponent } from '../components/landing-chart-gallery.component';
import { LandingClubShowcaseComponent } from '../components/landing-club-showcase.component';
import { LandingCtaComponent } from '../components/landing-cta.component';
import { LandingFeatureRowsComponent } from '../components/landing-feature-rows.component';
import { LandingHeroComponent } from '../components/landing-hero.component';
import { LandingMatchShowcaseComponent } from '../components/landing-match-showcase.component';
import { LandingNavComponent } from '../components/landing-nav.component';
import { LandingTeamCardsComponent } from '../components/landing-team-cards.component';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [LandingNavComponent, LandingHeroComponent, LandingTeamCardsComponent, LandingFeatureRowsComponent, LandingMatchShowcaseComponent, LandingChartGalleryComponent, LandingClubShowcaseComponent, LandingCtaComponent, SiteFooterComponent],
  template: `
    <app-landing-nav />
    <main class="landing">
      <app-landing-hero />
      <app-landing-team-cards />
      <app-landing-feature-rows />
      <app-landing-match-showcase />
      <app-landing-chart-gallery />
      <app-landing-club-showcase />
      <app-landing-cta />
      <app-site-footer />
    </main>
  `,
  styles: [`
    .landing {
      background:
        radial-gradient(60rem 28rem at 85% -6rem, color-mix(in srgb, var(--color-primary) 7%, transparent), transparent 70%),
        radial-gradient(44rem 22rem at 4% 4rem, color-mix(in srgb, var(--color-accent) 5%, transparent), transparent 70%);
      display: grid;
      gap: clamp(3rem, 8vw, 6rem);
      padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 4vw, 3rem) 1rem;
    }
  `],
})
export class LandingPageComponent {
  // Injected for its side effects: AppStateService owns theme resolution (system dark/light),
  // which otherwise never runs on the landing route — login/register bootstrap it the same way.
  protected readonly state = inject(AppStateService);
}
